import React from 'react'
import { Row, Col, Spinner } from 'react-bootstrap'
import useAddAddressUser from "./../../CustomHooks/User/useAddAddressUser"


const UserAddAddressComp = () => {
    
    const [isFormValid, isPress, loading, validateTitle, validateDetails, validatePhoneNumber, AddressTitle, changeAddressTitle, addressInDetails, changeAddressInDetails, phoneNumber, changePhoneNumber, AddAddressSubmit] = useAddAddressUser()
    
    return (
        <>
            <Row className="justify-content-start mb-3">
                <div className="fw-bold fs-30 pb-4"> Add New Address </div>
                <Col>
                    <input
                        value={AddressTitle}
                        onChange={changeAddressTitle}
                        onBlur={validateTitle}
                        type="text"
                        className="form-control d-block mt-3 px-3 h-60"
                        placeholder="Address Name"
                    />
                    <textarea
                        value={addressInDetails}
                        onChange={changeAddressInDetails}
                        onBlur={validateDetails}
                        className="form-control p-2 mt-3 h-200"
                        rows="4"
                        cols="50"
                        placeholder="Address in Details"
                    />
                    <input
                        value={phoneNumber}
                        onChange={changePhoneNumber}
                        onBlur={validatePhoneNumber}
                        type="text"
                        className="form-control d-block mt-3 px-3 h-60"
                        placeholder="Phone Number"
                    />
                    <button className="btn d-inline mt-4 orange-bg text-white px-5 py-3" onClick={AddAddressSubmit} disabled={!isFormValid}>
                        {isPress ? loading ? (<Spinner animation="border" variant="light" />) : (<span>Add Address</span>) : <span>Add Address</span>}
                    </button>
                </Col>
            </Row>
        </>
    )
}

export default UserAddAddressComp
